export const HOME_ROUTE = '/';
export const DASHBOARD_ROUTE = '/dashboard';
export const pharmacy_bookmarks = '/pharmacy-bookmarks';

export const ONBOARDING_ROUTE = '/on-boarding';
export const APPRECIATIONS_ROUTE = '/appreciations';
export const TIMESHEET_ROUTE = '/time-sheet';

export const NEWREQUEST_ROUTE = '/new-request';
export const ALLREQUEST_ROUTE = '/timeoffrequest';
export const SETTINGS_ROUTE = '/settings';
export const SUCCESSFULL_ROUTE = '/thank-you';
export const ALLEMPLOYEES_ROUTE = '/all-employees';
export const CHANGE_LOG_ROUTE = '/pharmacy-change-logs';
export const REALTIME_DEMO_ROUTE = '/realtime-demo';

export const EDIT_TIME_OFFR_REQUEST_ROUTE = '/edit-time-off-request';
export const CHAT_NOW = '/chat-now'
export const MY_PROFILE = '/my-profile';
export const ADD_PATIENTS = '/add-patient'

export const ALL_PATIENTS = '/pharmacy-patients'
export const PHARMACY_PRINT_OAT_LOG = '/pharmacy-patient-oat'
export const PHARMACY_WORK_SPACE = '/work-space'
export const PHARMACY_PATIENT_PROFILE = '/pharmacy-patient-profile'

export const PHARMACY_INFORMATION_UPDATE_FORM = '/pharmacy-information-update-form'
export const PHARMACY_PRESCRIPTION_TRASNSFER_FORM = '/pharmacy-prescription-transfer-form'
export const pharmacy_Emergency_Supply_OAT_medications_form = '/pharmacy-Emergency-Supply-OAT-medications-form'
export const pharmacy_medication_form = '/pharmacy-medication-form'
export const pharmacy_tb_skin_test_logs = '/pharmacy-tb-skin-test-logs'
export const pharmacy_tb_screening_form_logs = '/pharmacy-tb-screening-form-logs'
export const pharmacy_tb_form = '/pharmacy-tb-form'
export const pharmacy_pharmacare = '/pharmacy-pharmacare'

export const missing_Rx_Requirements = '/pharmacy-missing-rx-requirement-form'
export const pharmacy_emergency_supply_continuity_form = '/pharmacy-emergency-supply-continuity-form'
export const patient_agreement_for_take_home_dosing = '/pharmacy-Patient-Agreement-Home-Dosing'
export const pharmacy_Plan_G_Form = '/pharmacy-Plan-G-Form'

export const pharmacy_Plan_Z_Form = '/pharmacy-Plan-Z-Form'
export const pharmacy_doctor_communication_form = '/pharmacy-doctor-communication-form'
export const pharmacy_Pharmacist_Prescriber_Communication = '/pharmacy-Pharmacist-Prescriber-Communication'

export const pharmacy_Team_Notes = '/pharmacy-team-notes'
export const pharmacy_original_prescription_form = '/pharmacy-original-prescription-form'

export const pharmacy_tb_skin_test_mantoux_form = '/pharmacy-tb-skin-test-mantoux-form'

export const pharmacy_search_module = '/search-result'
export const pharmacy_all_notifications = '/all-previous-notifications'
export const pharmacy_front_profile = '/pharmacy-profile'
export const pharmacy_file_manager = '/pharmacy-file-manager'

export const pharmacy_fax_log = '/pharmacy-fax-log'
export const pharmacy_break_parroll_settings = "/pharmacy-break-payroll-settings"
export const pharmacy_compounds = '/pharmacy-compound'
export const pharmacy_compound_agreement_form = '/pharmacy-compound-agreement-form'

export const pharmacy_compound_price_list = '/pharmacy-compound-price-list'
export const pharmacy_controlled_order_request = '/pharmacy-controlled-order-request'
export const pharmacy_order_compound_form = '/pharmacy-order-compound-form'
export const pharmacy_order_compounding_form = '/pharmacy-order-compounding-form'
export const pharmacy_compound_quotations = '/pharmacy-compound-quotations'
export const pharmacy_compound_dins = '/pharmacy-compound-dins'
export const pharmacy_compound_logs = '/pharmacy-compound-logs'
export const pharmacy_compound_due_billing = '/pharmacy-compound-due-billing'

export const pharmacy_create_manual_delivery = '/pharmacy-create-manual-delivery'
export const pharmacy_route_delivery = '/pharmacy-route-delivery'
export const pharmacy_driver = '/pharmacy-driver'
export const pharmacy_deliveries_supervisor = '/pharmacy-deliveries-supervisor'
export const pharmacy_delivery = '/pharmacy-delivery'
export const pharmacy_missed_deliveries = '/pharmacy-missed-deliveries'
export const pharmacy_archived_deliveries = '/pharmacy-archived-deliveries'
export const pharmacy_driver_clinic_call_logs = '/pharmacy-driver-clinic-call-logs'
export const pharmacy_tranfer_patient_concent = '/pharmacy-tranfer-patient-concent'
export const pharmacy_sig_check_ai = '/pharmacy-sig-check-ai'
export const pharmacy_dwi = '/pharmacy-dwi-patient-data'
export const pharmacy_investigate_rx = '/pharmacy-investigate-rx'
export const pharmacy_pharmanet_profile = '/pharmacy-pharmanet-profile'
export const pharmacy_rxnumber_date_sync = '/pharmacy-mark-delivered'
export const pharmacy_delivery_lables = '/pharmacy-delivery-lables'
export const pharmacy_recurrence_delivery = '/pharmacy-recurrence-delivery'
export const pharmacy_expiring_rx = '/pharmacy-expiring-rx'
export const pharmacy_expiring_rx_v2 = '/pharmacy-expiring-rx-v2'
export const pharmacy_drugs_billing = '/pharmacy-drugs-billing'
export const pharmacy_oat_prescriptions = '/pharmacy-oat-prescriptions'
export const pharmacy_patient_counselling = '/pharmacy-patient-counselling'
export const pharmacy_patient_soap_notes = '/pharmacy-patient-soap-notes'
export const pharmacy_rx_signature_request_list = '/pharmacy-rx-signature-request-list'
export const pharmacy_med_review_logs = '/pharmacy-med-review-logs'
export const pharmacy_create_soap_notes = '/pharmacy-create-soap-notes'
export const pharmacy_soap_notes_logs = '/pharmacy-soap-notes-logs'
export const pharmacy_med_review_logs_v2 = '/pharmacy-med-review-logs-v2'
export const pharmacy_patient_med_review_sign = '/pharmacy-patient-med-review-sign'

export const pharmacy_patient_blister_pack = '/pharmacy-add-patient-blister-pack'
export const pharmacy_blister_patients = '/pharmacy-patient-blister-pack'
export const pharmacy_blister_packs = '/pharmacy-blister-packs'
export const pharmacy_blister_daily_packs = '/daily-blister-pack'
export const pharmacy_blister_pack_on_shelf = '/pharmacy-blister-pack-on-shelf'
export const pharmacy_blister_sheets = '/pharmacy-blister-sheets'
export const pharmacy_blister_sheets_report = '/pharmacy-blister-sheets-report'

export const pharmacy_patient_vials_pack = '/pharmacy-patient-vials-pack'
export const pharmacy_add_vials_patient = '/pharmacy-add-vials-patient'
export const pharmacy_vials_packs = '/pharmacy-vials-packs'
export const pharmacy_dailyvials_packs = '/pharmacy-dailyvials-packs'

// Super Nova (Admin OTP verification gate)
export const pharmacy_super_nova_verification = '/pharmacy-super-nova-verification'
export const pharmacy_half_baked = '/pharmacy-half-baked'

//Routes To Manager MEdications
export const pharmacy_add_medication_patients = '/pharmacy-add-medication-patients'
export const pharmacy_speciality_pack = '/pharmacy-speciality-pack'
export const pharmacy_speciality_medication_packs = '/pharmacy-speciality-medication-packs'
export const pharmacy_dailymedication_packs = '/pharmacy-dailymedication-packs'

//Routes To Manager Invoice
export const pharmacy_generate_invoice = '/generate-invoice'
export const pharmacy_previous_invoices = '/pharmacy-previous-invoices'
export const pharmacy_doctor_note_form = '/pharmacy-doctor-note-form'
export const pharmacy_consent_form_logs = '/pharmacy-consent-form-logs'

//Routes To Manager ARV
export const ADD_ARV = "/pharmacy-pateint-create-arv"
export const ARV_LIST = "/pharmacy-patient-arv"
export const pharmacy_memo = "/pharmacy-memo"
export const upload_prescription = "/pharmacy-upload-prescription"
export const pharmacy_uploaded_prescriptions_list = "/pharmacy-uploaded-prescriptions-list"

//Routes To Manager Revenue
export const pharmacy_daily_revenue = "/pharmacy-daily-revenue"
export const pharmacy_cash_change = "/pharmacy-cash-change"
export const pharmacy_deposit_info = "/pharmacy-deposit-info"
export const pharmacy_hand_cash = "/pharmacy-hand-cash"

//Routes To Manager FDA FORM
export const create_new_fda_form = "/pharmacy-frequent-dispensing-authorization"
export const all_generated_fda_form_list = "/pharmacy-frequent-dispensing-log"
export const pharmacy_expiring_frequent_dispense = "/pharmacy-expiring-frequent-dispense"
export const pharmacy_expired_frequent_dispense = "/pharmacy-expired-frequent-dispense"
export const pharmacy_fda_audit = "/pharmacy-fda-audit"
export const pharmacy_frequent_dispensing_authorization_timeline = "/pharmacy-frequent-dispensing-authorization-timeline"
//Routes To Manager Inventory
export const pharmacy_inventory_list = "/pharmacy-inventory-list"
export const pharmacy_inventory_accountability = "/pharmacy-inventory-accountability"
export const pharmacy_fridge_temperature_log = "/pharmacy-fridge-temperature-log"
export const pharmacy_total_reversed = "/pharmacy-total-reversed" // route/menu commented out; kept for appLayout/sidebar


// Routes To OAT FORM
export const pharmacy_patient_route = "/pharmacy-patient-route"
export const pharmacy_add_patient_route = '/pharmacy-add-patient-oat'
export const pharmacy_reminder_notes = '/pharmacy-reminder-notes'
export const pharmacy_delivered_rx_reasons = '/pharmacy-delivered-rx-reasons'

// Travel Routes
export const pharmacy_add_travel_patient = '/pharmacy-add-travel-patient'
export const pharmacy_add_travel_pack = '/pharmacy-add-travel-pack'
export const pharmacy_travel_logs = '/pharmacy-travel-logs'
export const pharmacy_billing_due = '/pharmacy-billing-due'
export const pharmacy_travel_returning_patients = '/pharmacy-travel-returning-patients'
export const pharmacy_ongoing_prescritiptions = '/pharmacy-ongoing-prescritiptions'
export const pharmacy_returned_patches = '/pharmacy-returned-patches'
export const pharmacy_fentanyl_patch_log = '/pharmacy-fentanyl-patch-log'
export const pharmacy_reversed_deliveries = "/pharmacy-reversed-deliveries"

// App Routes
export const pharmacy_app_prescriptions = '/pharmacy-app-prescriptions'
export const pharmacy_order_transfer = '/pharmacy-order-transfer'
export const pharmacy_order_new = '/pharmacy-order-new'
export const pharmacy_view_order_details = '/pharmacy-order'
export const pharmacy_app_user_list = '/pharmacy-app-user-list'
export const pharmacy_app_announcements = '/pharmacy-app-announcements'
export const pharmacy_app_notification_list = '/pharmacy-app-notification-list'
export const pharmacy_app_refill_request = '/pharmacy-app-refill-request'
export const pharmacy_app_patient_chat = '/pharmacy-app-patient-chat'
export const pharmacy_app_insurance_documents = '/pharmacy-app-insurance-documents'
export const pharmacy_app_pharmacy_services = '/pharmacy-app-pharmacy-services'
export const pharmacy_app_pharmacy_services_alias = '/app/pharmacy-services'

//Admin Routes
export const pharmacy_timeoff = '/pharmacy-timeoff'
export const pharmacy_create_new_task = '/pharmacy-create-new-task'
export const pharmacy_task_management = '/pharmacy-task-management'
export const pharmacy_tasks = '/pharmacy-tasks'
export const pharmacy_certificate_template = '/pharmacy-certificate-templates'
export const pharmacy_assign_certificate = '/pharmacy-assign-certificate'
export const pharmacy_assign_certificate_employee = '/pharmacy-assign-certificate-employee'
export const pharmacy_user = '/pharmacy-user'
export const pharmacy_settings = '/pharmacy-settings'
export const pharmacy_create_certificate = 'pharmacy-create-certificate'
export const pharmacy_team_avalibility = '/pharmacy-team-avalibility'
export const pharmacy_edit_certificate = 'pharmacy-edit-certificate'

//Team Routes
export const pharmacy_tasks_list = '/pharmacy-tasks-list'
export const pharmacy_team_attendance = '/pharmacy-team-attendance'
export const pharmacy_check_out_in = '/pharmacy-checkIn-out'
export const pharmacy_department = '/pharmacy-department'
export const pharmacy_holidays_calander = '/pharmacy-holidays-calander'
export const pharmacy_accountability = '/pharmacy-accountability'
export const pharmacy_pharmacist_signature_updation = '/pharmacy-pharmacist-signature'

//Book Appointments
export const pharmacy_juno_appointment = '/pharmacy-juno-appointment'
export const pharmacy_appointment_logs = '/pharmacy-appointment-log'

//Packaging
export const pharmacy_packaging_order_preview = '/pharmacy-packaging-order-preview'
export const pharmacy_packaging_processing = '/pharmacy-packaging-processing'
export const pharmacy_packaging_orders = '/pharmacy-packaging-orders'
export const pharmacy_packaging_all_d_logs = '/pharmacy-packaging-all-d-logs'
export const pharmacy_packaging_din_management = '/pharmacy-packaging-din-management'
export const pharmacy_packaging_liquid_processing = '/pharmacy-packaging-today-liquid-data'
export const pharmacy_packaging_prn_processing = '/pharmacy-packaging-today-prn-data'
export const pharmacy_packaging_invoices = '/pharmacy-packaging-invoices'
export const pharmacy_packaging_monthly_invoice = '/pharmacy-packaging-monthly-invoice'

//Vaccination
export const pharmacy_vaccine_passport = '/pharmacy-vaccine-passport'
export const pharmacy_vaccine_logs = '/pharmacy-vaccine-logs'

//SMS
export const pharmacy_sms_tabs = '/pharmacy-sms'

//Blister Packaging
export const pharmacy_blister_packaging_processing = '/pharmacy-blister-packaging-processing'
export const pharmacy_blister_packaging_prn_processing = '/pharmacy-blister-packaging-prn-processing'
export const pharmacy_blister_packaging_liquid_processing = '/pharmacy-blister-packaging-liquid-processing'
export const pharmacy_blister_packaging_orders = '/pharmacy-blister-packaging-orders'
export const pharmacy_blister_packaging_packmed_files = '/pharmacy-blister-packaging-packmed-files'
export const pharmacy_blister_packaging_invoices = '/pharmacy-blister-packaging-invoices'
export const pharmacy_blister_packaging_monthly_invoice = '/pharmacy-blister-packaging-monthly-invoice'

//Account Ability
export const pharmacy_accountability_new_rx = '/pharmacy-accountability-new-rx'
export const pharmacy_accountability_prep_check = '/pharmacy-accountability-prep-check'
export const pharmacy_accountability_pickup_log = '/pharmacy-accountability-pickup-log'
export const pharmacy_accountability_final_check = '/pharmacy-accountablity-final-check'
export const pharmacy_accountability_today_missed_rx = '/pharmacy-accountability-actions'
export const pharmacy_accountability_all_reports = '/pharmacy-accountability-reports'
export const pharmacy_accountability_prep_for_new_rx = '/pharmacy-accountability-prep-for-new-rx'
export const pharmacy_accountability_after_process_prep_check = '/pharmacy-accountability-after-process-prep-check'
export const pharmacy_mark_flexi = '/pharmacy-mark-flexi'
export const pharmacy_erx = '/pharmacy-erx'

//Analytics
export const pharmacy_packaging_analytics = '/pharmacy-packaging-analytics'
export const pharmacy_accountability_upload_pics = '/drug-visual-intake-missing-dins'

//Payroll
export const pharmacy_admin_payroll = '/bookkeepers'
export const bookkeeper_mobile_login = '/upload-bills'
export const pharmacy_accounts = '/accounts'
export const pharmacy_payroll_signature = '/pharmacy-payroll-signature'






















